export const config = {
	googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
	apiUrl: import.meta.env.VITE_API_URL,
	googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
} as const
